/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_EditInputs */

const en_directory_submit_content_edit = /** @type {(inputs: Directory_Submit_Content_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit details`)
};

const zh_directory_submit_content_edit = /** @type {(inputs: Directory_Submit_Content_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑详情`)
};

/**
* | output |
* | --- |
* | "Edit details" |
*
* @param {Directory_Submit_Content_EditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_edit = /** @type {((inputs?: Directory_Submit_Content_EditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_EditInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_edit(inputs)
	return zh_directory_submit_content_edit(inputs)
});
export { directory_submit_content_edit as "directory.submit.content.edit" }